import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { formatPhone } from 'helpers/Formatter';
import { getTranslatedString } from 'helpers/i18n';
import ApplicantCard from 'components/ui/ApplicantCard/ApplicantCard';
import { bypassApplicant, approveApplicant, inviteApplicant } from '../renewals/store/actions';
import { openEditLease } from 'actions/LeaseDetailsActions';
import { showFailure, showSuccess } from 'actions/notificationActions';

const StyledCardContainer = styled.div`
  margin-bottom: 24px;
`;

const LeaseHolderCard = ({
  cotenant,
  leaseDetails,
  bypassApplicant,
  approveApplicant,
  inviteApplicant,
  openEditLease,
  showSuccess,
  showFailure,
}) => {
  const callActionAndReload = async action => {
    try {
      await action;
      await openEditLease(leaseDetails.id);
      showSuccess(getTranslatedString('success'));
    } catch {
      showFailure(getTranslatedString('unknownError'));
    }
  };

  const calculateActions = (cotenantId, status) => {
    if (status === 'pending_application') {
      return {
        primaryText: getTranslatedString('landlordPortal.rentRoll.renewals.remindApplicant'),
        primaryAction: () => {
          return inviteApplicant(cotenantId);
        },
        secondaryText: getTranslatedString('landlordPortal.rentRoll.renewals.bypassApplicant'),
        secondaryAction: () => {
          return callActionAndReload(bypassApplicant(cotenantId));
        },
      };
    } else if (status === 'application_completed') {
      return {
        secondaryText: getTranslatedString('landlordPortal.rentRoll.renewals.approveApplicant'),
        secondaryAction: () => {
          return callActionAndReload(approveApplicant(cotenantId));
        },
      };
    } else if (status === 'lease_holder') {
      return {
        secondaryText: getTranslatedString('landlordPortal.rentRoll.renewals.sendApplication'),
        secondaryAction: () => {
          return callActionAndReload(inviteApplicant(cotenantId));
        },
      };
    }
  };

  const { id, renewal_status, full_name, email, phone_number } = cotenant;
  const canPerformActions = ['pending_tenant_applications', 'pending_send_renewal'].includes(
    leaseDetails.renewal_status
  );
  const actions = canPerformActions ? calculateActions(id, renewal_status) : {};

  return (
    <StyledCardContainer>
      <ApplicantCard
        status={renewal_status}
        fullName={full_name}
        email={email}
        phoneNumber={formatPhone(phone_number)}
        primaryAction={actions.primaryAction}
        primaryActionText={actions.primaryText}
        secondaryAction={actions.secondaryAction}
        secondaryActionText={actions.secondaryText}
      />
    </StyledCardContainer>
  );
};

const mapStateToProps = store => ({
  leaseDetails: store.leaseDetails.leaseDetails,
});

const mapDispatchToProps = {
  bypassApplicant,
  approveApplicant,
  inviteApplicant,
  openEditLease,
  showSuccess,
  showFailure,
};

export default connect(mapStateToProps, mapDispatchToProps)(LeaseHolderCard);
